import callAPI from "../callApi";
import path from "../variables";

const base = `${path.base}/alerts`;

const Alerts = {
	getExpirations: (filter?: string) =>
		callAPI("GET", `${path.base}/automobile/expiration-alerts${filter || ""}`, "", "getting expiration alerts"),

	// ── Système d'alertes configurable (réservé aux admins) ──
	getAll: (filter?: string) =>
		callAPI("GET", `${base}${filter || ""}`, "", "getting alerts"),
	unreadCount: () =>
		callAPI("GET", `${base}/unread-count`, "", "getting unread alerts count", { skipCache: true }),
	markRead: (uuid: string) =>
		callAPI("POST", `${base}/${uuid}/read`, "", "marking alert read"),
	markAllRead: () =>
		callAPI("POST", `${base}/read-all`, "", "marking all alerts read"),
	rules: () =>
		callAPI("GET", `${path.base}/alert-rules`, "", "getting alert rules", { skipCache: true }),
	saveRule: (data: { event_key: string; enabled: boolean; severity?: string; config?: any }) =>
		callAPI("PUT", `${path.base}/alert-rules`, data, "saving alert rule"),
};

export default Alerts;
